<span class="ion-icon" aria-hidden="true" [style.--ion-icon-url]="iconUrl()"></span>
